export default "__VITE_ASSET__BZot38T0__"